import { CaretDoubleLeftIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ArrowDupLeft = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CaretDoubleLeftIcon {...rest} size={Sizes[size]} color={fill} />;
};

ArrowDupLeft.displayName = 'ArrowDupLeft';
